<template>
  <div class="header">
    <div class="header-content wrapper">
      <div class="logo">
        <img src="../assets/img/heartbeat.png" alt="">
      </div>
      <ul class="nav">
        <li :class="page === 1 ? 'pitch-on' : ''">
          <div class="link" @click="jump(1)">首页<b></b></div>
        </li>
        <li :class="page === 2 ? 'pitch-on' : ''">
          <div class="link" @click="jump(2)">产品介绍<b></b></div>
        </li>
        <li :class="page === 3 ? 'pitch-on' : ''">
          <div class="link" @click="jump(3)">联系我们<b></b></div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'Header',
  props: {},
  data() {
    return {
    };
  },
  computed: {
    ...mapState([
      'page',
    ]),
  },
  watch: {
  },
  mounted() {
  },
  methods: {
    ...mapMutations([
      'setState',
    ]),
    jump(value) {
      this.setState({ page: value });
      if (value === 1) {
        this.$router.push({ path: '/' });
      } else if (value === 2) {
        this.$router.push({ path: '/aboutUs' });
      } else if (value === 3) {
        this.$router.push({ path: '/contactUs' });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.header {
  height: 154.7px;
  width: 100%;
  padding-bottom: 56.7px;
  .header-content {
    height: 91px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    .logo {
      background: url(../assets/img/logo3.png) no-repeat 0 0;
      background-size: 231.7px 56px;
      height: 56px;
      width: 231.7px;
      position: relative;
      img {
        position: absolute;
        top: -35px;
        left: -74.9px;
        width: 387.8px;
        height: 154.7px;
      }
    }
    .nav {
      // width: 600px;
      height: 35px;
      display: flex;
      li {
        float: left;
        position: relative;
        >.link {
          font-size: 25px;
          color: #353535;
          margin: 0 23px;
          display: block;
          line-height: 35px;
          text-decoration: none;
          b {
            display: block;
            width: 0px;
            margin: 0 auto;
            height: 4px;
            border-radius: 1.5px;
            background: #ff40a0;
            -webkit-transition: all .3s ease-in-out;
            -moz-transition: all .3s ease-in-out;
            transition: all .3s ease-in-out;
          }
        }
      }
      li:hover {
        cursor: pointer;
        >.link {
          color: #ff40a0;
          position: relative;
          b {
            width: 100%;
          }
        }
      }
      .pitch-on {
        >.link {
          color: #ff40a0;
          position: relative;
          b {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>
